import Vue from 'vue'
import ElementUI from 'element-ui';
Vue.use(ElementUI)

export default {
    data() {
        return {
            navList: [
                {
                    menuName: '项目管理',
                    menuJoint: '/man-hour',
                    menuIcon: 'iconwork-order',
                    menuMuid: '1',
                    children: [
                        {
                            menuName: '项目管理',
                            menuJoint: '/project',
                            menuIcon: '#iconwendang',
                            menuMuid: '1-1',
                        },
                        {

                        },
                        {}
                    ]
                },
                {
                    menuName: '供应商管理',
                    menuMuid: '2',
                    menuIcon: 'iconyonghuguanli',
                    children: [
                        {
                            menuName: '供应商管理',
                            menuJoint: '/provider',
                            menuIcon: '#iconwomen',
                            menuMuid: '2-1',
                        }, {}, {}

                    ]
                },
                {
                    menuName: '采购管理',
                    menuMuid: '3',
                    menuIcon: 'iconshenqingbaoxiao',
                    children: [
                        {
                            menuName: '供应商管理',
                            menuJoint: '/purchase-list',
                            menuIcon: '#iconbaoxiao',
                            menuMuid: '3-1',
                        }, {}, {}

                    ]
                },
            ]
        }
    },
    mounted() {
    },
    methods: {
        jumpTo(path) {
            this.$router.push(path)
        }
    }
}
